import * as _ from 'lodash';
import React, { useEffect, useRef, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import State from 'src/models/State';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import moment from 'moment';
// import Account from 'src/models/Account';
import PagedResultSet from 'src/models/common/PagedResultSet';
import useFetch from 'use-http';
import EmployeePay from 'src/models/personnel/EmployeePay';
import Vendor from 'src/models/AP/Vendor';
import VendorReportsDialog from '../dialogs/VendorReportsDialog';
import Ap1099MaintenanceDialog from '../dialogs/Ap1099MaintenanceDialog';
import CompanyMaintenanceDialog from '../dialogs/CompanyMaintenanceDialog';
import Ap1099ReportDialog from '../dialogs/Ap1099ReportDialog';
import VendorExcelExportDialog from '../dialogs/VendorExcelExportDialog';
import VendorSearch, { IVendorSearchCriteria } from '../components/VendorSearch';
import DialogList from 'src/dialogs';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import AddVendorExDialog from '../dialogs/AddVendorExDialog';
import FindVendorDialog from '../dialogs/FindVendorDialog';
import WarningDialog from '../dialogs/WarningDialog';
import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
import APTermsDialog from '../dialogs/APTermsDialog';
import Term from 'src/models/AP/Term';
import VendorDefaultAccount from 'src/models/AP/VendorDefaultAccount';
import VendorDoc from 'src/models/AP/VendorDoc';
import VendorDocumentManagementDialog from '../dialogs/VendorDocumentManagementDialog';
import { FaPlusCircle, FaBuilding, FaTrash, FaRegSave, FaFolderOpen, FaFileInvoice  } from 'react-icons/fa';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { BiArrowToLeft, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToRight } from 'react-icons/bi';
import { VscGraph } from 'react-icons/vsc';
import LedgerAccount from 'src/models/AP/GeneralLedgerAccount';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { UserRoles } from 'src/models/UserRole';
import APNavBar from '../APNavBar';
import PersonnelToast from 'src/components/personnel/components/PersonnelToast';

const VendorsPage = () => {
    const dispatch = useDispatch();
    const { get, put, post, del, response } = useFetch();
    const [toast, setToast] = useState<{ message: string; color?: string; persistent?: boolean; } | null>(null);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [vendors, setVendors] = useState<PagedResultSet<Vendor>>(undefined);
    const [vendorDefaultAccounts, setVendorDefaultAccounts] = useState<Array<VendorDefaultAccount>>(undefined);
    const [vendorDocs, setVendorDocs] = useState<Array<VendorDoc>>([]);
    const [selectedVendorDefaultAccount, setSelectedVendorDefaultAccount] = useState<number>(-1);
    const [vendorSearchOptions, setVendorSearchOptions] = useState<ODataOptions>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const {getValues, register, reset, handleSubmit, errors, formState, setValue } = useForm();
    const { isDirty, dirtyFields } = formState;
    const [vendorSearchTerm, setVendorSearchTerm] = useState<string>(undefined);
    const [selectedEmployeePay] = useState(undefined);
    const [selectedVendor, setSelectedVendor] = useState(0);
    const [vendorPositionInput, setVendorPositionInput] = useState<string>('');
    const [vendorPositionError, setVendorPositionError] = useState<string>('');
    const [terms, setTerms] = useState<Term[]>([
        { id: 1, termNumber: 0, description: 'Upon Receipt', days: 0 },
        { id: 2, termNumber: 1, description: 'Net 15', days: 15 },
        { id: 3, termNumber: 2, description: 'Net 30', days: 30 },
        { id: 4, termNumber: 3, description: 'Net 45', days: 45 },
    ]);
    const [termDescriptions, setTermDescriptions] = useState<{ value: string; label: string; }[]>();

    const appContext = useContext<IAppContextState>(AppContext);
    const isAccountingAdmin = appContext.currentUser.role === UserRoles.AccountingAdmin;

/*     const accounts = [
        { id: 1, accountNumber: '2-5-07-108-0000-9', description: 'A DESCRIPTION' },
        { id: 2, accountNumber: '2-5-07-108-0000-9', description: 'A DESCRIPTION' },
    ]; */

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    // SelectedEmployeePay changes on Update Pay
    useEffect(() => {
        console.log('resetting the form');
        reset(initializeData(selectedEmployeePay));
    }, [selectedEmployeePay]);

    useEffect(() => {
        if (!!vendors && !!vendors.items) {
            reset(vendors?.items[selectedVendor]);
        }
    }, [selectedVendor]);

    useEffect(() => {
        if (!!vendorSearchOptions) {
            getVendors(!!vendorSearchTerm ? vendorSearchTerm : '');
        }
    }, [vendorSearchOptions]);

    // Add actions to perform when the vendors list is populated
    useEffect(() => {
        if (!!vendors && vendors?.items.length > 0) {
            reset(vendors.items[selectedVendor]);
            getVendorDefaultAccounts(vendors?.items[0]?.vendorNumber);
            console.log('Vendors list retrieved!');
        }
    }, [vendors]);

    useEffect(() => {
        if (!!vendorSearchTerm || vendorSearchTerm === '') {
            // vendors.items = [];
            // setVendors(vendors);
            resetVendorSearchOptions();
        }
    }, [vendorSearchTerm]);

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VendorsPage onCreate()');

        // AP_VENDOR.TERM_NO stores the term's number (0-3, -1 for Other), not its description -
        // using the description as the option value meant defaultVal (built from termNumber) could
        // never match an option, so the dropdown always showed blank regardless of what a vendor
        // actually had saved.
        setTermDescriptions(
            terms?.map(term => ({
                value: term.termNumber + '',
                label: term.description
            }))
        );

        getStates();
        initializeVendorSearchSettings();
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VendorsPage onDestroy()');
    };

    /**
     * Gets the list of United States (Merica) not React states
     */
    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to get the States Data!!!');
        }
    };

    const resetVendorSearchOptions = () => {
        vendors.items = [];
        setVendors(vendors);
        setFetchNextPage(true);
        let newVendorSearchOptions = _.cloneDeep(vendorSearchOptions);
        newVendorSearchOptions.clearFilters();
        newVendorSearchOptions.addPaging(1, 50);
        // newVendorSearchOptions.addSkipTop(0, 50);
        setVendorSearchOptions(newVendorSearchOptions);
    };

    const getVendors = async (filter: string) => {
        if (!!filter && filter.length > 0) {
            if (isNaN(Number(filter))) {
                vendorSearchOptions?.addFilter(new ODataFilter('vd.NAME1', ODataFilterOperators.Contains, filter));
            } else {
                vendorSearchOptions?.addFilter(new ODataFilter('vd.VNDR_NO', ODataFilterOperators.Equals, filter));
                vendorSearchOptions?.addFilter(new ODataFilter('vd.NAME1', ODataFilterOperators.Contains, filter));
            }
        }

        const queryString = vendorSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/vendors${queryString}`);

        if (response.ok) {
            if (vendorSearchOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(vendors);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setVendors(tempResult);
            } else {
                setVendors(result);
            }
            setFetchNextPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get vendor data!!!');
        }
        vendorSearchOptions.clearFilters();
    };

    const getVendorDefaultAccounts = async (vendorNumber: number) => {
        let result = await get(`/v1.0/AccountsPayable/defaultaccounts/vendor/${vendorNumber}`);

        if (response.ok && result?.items?.length > 0) {
            setVendorDefaultAccounts([]);
            setVendorDefaultAccounts(result?.items);
        } else {
            setVendorDefaultAccounts([]);
            setVendorDefaultAccounts([{id: 0, accountNumber: 'Enter Account No', description: 'Enter Description' }]);
            console.log('Unable to get the States Data!!!');
        }
    };

    // Port of ap_vendor.fmt's W_DOCUMENTS window - mirrors DepositReconciliationPage.tsx's own
    // deposit-document handling (getDepositDocs/addDepositDoc/deleteDepositDoc/downloadDepositDocBlob)
    // but simpler, since AP_VENDOR_DOCUMENT always stores the file in-database - no S3 fallback.
    const getVendorDocs = async (vendorNumber: number) => {
        let result = await get(`/v1.0/AccountsPayable/vendor/${vendorNumber}/documents`);

        if (response.ok) {
            setVendorDocs(Array.isArray(result) ? result : []);
        } else {
            setVendorDocs([]);
            console.log('Unable to get vendor documents!!!');
        }
    };

    const handleOpenVendorDocuments = (vendorNumber: number) => {
        if (!vendorNumber) {
            return;
        }
        getVendorDocs(vendorNumber);
        showDialog(DialogList.MANAGE_VENDOR_DOCUMENTS);
    };

    const handleAddVendorDoc = async (description: string, file: File) => {
        const vendorNumber = vendors?.items[selectedVendor]?.vendorNumber;
        if (!vendorNumber) {
            return;
        }

        // Raw fetch (matching AccountsReceivableServiceContext.tsx's addDepositDoc) since this sends
        // the file's raw bytes as the body - use-http's post() is built around JSON payloads.
        const params = new URLSearchParams({ description: description || '', fileName: file.name });
        const baseUrl = process.env.REACT_APP_BASE_API_URL;
        const url = `${baseUrl}/v1.0/AccountsPayable/vendor/${vendorNumber}/documents?${params}`;
        const jwtToken = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');

        try {
            const result = await fetch(url, {
                method: 'POST',
                body: file,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    'Content-Type': file.type || 'application/octet-stream'
                }
            });

            if (result.ok) {
                getVendorDocs(vendorNumber);
            } else {
                console.log('Unable to add vendor document!!!');
            }
        } catch (e) {
            console.log('Unable to add vendor document!!!', e);
        }
    };

    const handleDeleteVendorDoc = async (docId: number) => {
        const vendorNumber = vendors?.items[selectedVendor]?.vendorNumber;
        let result = await del(`/v1.0/AccountsPayable/vendor/documents/${docId}`);

        if (response.ok) {
            getVendorDocs(vendorNumber);
        } else {
            console.log('Unable to delete vendor document!!!' + result);
        }
    };

    const downloadBlobResponseAsFile = (blob: Blob, fileName: string) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'document';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadVendorDoc = async (doc: VendorDoc) => {
        if (doc.hasBlob) {
            await get(`/v1.0/AccountsPayable/vendor/documents/${doc.id}/blob`);
        } else {
            // Same generic S3BucketController.GetFile endpoint AccountsReceivableServiceContext.tsx's
            // downloadDepositDocFromS3 uses - no vendor-specific S3 download route needed.
            await get(`/v1.0/s3bucket/${encodeURIComponent(doc.s3Key)}`);
        }

        if (response.ok) {
            const blob = await response.blob();
            downloadBlobResponseAsFile(blob, doc.originalFileName);
        } else {
            console.log('Unable to download vendor document!!!');
        }
    };

    const handleUpdateVendorDoc = async (docId: number, description: string, file: File) => {
        const vendorNumber = vendors?.items[selectedVendor]?.vendorNumber;
        if (!vendorNumber) {
            return;
        }

        const params = new URLSearchParams({ description: description || '', fileName: file.name });
        const baseUrl = process.env.REACT_APP_BASE_API_URL;
        const url = `${baseUrl}/v1.0/AccountsPayable/vendor/documents/${docId}?${params}`;
        const jwtToken = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');

        try {
            const result = await fetch(url, {
                method: 'PUT',
                body: file,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    'Content-Type': file.type || 'application/octet-stream'
                }
            });

            if (result.ok) {
                getVendorDocs(vendorNumber);
            } else {
                console.log('Unable to update vendor document!!!');
            }
        } catch (e) {
            console.log('Unable to update vendor document!!!', e);
        }
    };

    const initializeData = (data: EmployeePay) => {
        let newData: EmployeePay = { ...data };

        if (newData) {
            newData.changeDate = newData.changeDate ? (moment(newData.changeDate).format('YYYY-MM-DD') as unknown as Date) : null;
            newData.effectiveDate = newData.effectiveDate ? (moment(newData.effectiveDate).format('YYYY-MM-DD') as unknown as Date) : null;
        }

        return newData;
    };

    const initializeVendorSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'VNDR_NO',
            pageNumber: 1,
            columns: []
        };
        setVendorSearchOptions(ODataOptions.from(tableConfig).addOrderBy('VendorNumber', ODataOrderByDirection.Ascending));
    };

    /**
     * @returns United States (Merica) not React states
     */
    const stateDropdownOptions = () => {
        return states
            ? states?.items?.map((st: State) => {
                // AP_VENDOR.STATE is varchar(2) - the abbreviation ("TX"), not the numeric lookup
                // id or the full name - confirmed against live data.
                return { value: st.abbreviation, label: st.name };
            })
            : [];
    };

    const onSubmit = async (data: Vendor) => {
        onSaveVendor(data);
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    const handleTerms = (t: Term[]) => {
        console.log(t);
        setTerms(t);

        let descriptions = t?.map(term => ({
            value: term.termNumber + '',
            label: term.description
        }));

        setTermDescriptions(descriptions);
        console.log(terms);
    };

    const onSaveVendor = async (data: Vendor) => {
        // console.log(getValues(`termNumber`));
        console.log(dirtyFields);
        if (isDirty) {
            if (getValues(`vendorNumber`) === '') {
                addVendor(getPreparedCreateVendorPayload(data, true));
            } else {
                updateVendor(getPreparedCreateVendorPayload(data, false));
            }
        }
    };

    // AP_VENDOR.PHONE/FAX are varchar(10) - raw digits only, no formatting characters (confirmed
    // against live data). The Phone/FAX inputs are plain free-text with no digit mask, so a
    // formatted value like "(555) 123-4567" would overflow the column and fail the ENTIRE vendor
    // update with a SQL truncation error - not just silently drop the phone number.
    const sanitizePhoneNumber = (value: string) => value?.replace(/\D/g, '').slice(0, 10);

    const getPreparedCreateVendorPayload = (data: Vendor, create: boolean) => {
        let createVendorPayload = {
            address: data.address,
            address2: data.address2,
            city: data.city,
            emailAddress: data.emailAddress,
            faxNumber: sanitizePhoneNumber(data.faxNumber),
            isActive: 1,
            phoneNumber: sanitizePhoneNumber(data.phoneNumber),
            state: data.state,
            taxId: data.taxId,
            taxType: GetIrsCategoryTypeIdFromString(data.taxType),
            // The Terms select's own option values are now the term number itself (see onCreate/
            // handleTerms), so this can be used directly - no description lookup needed.
            termNumber: data.termNumber !== undefined ? Number(data.termNumber) : 0,
            useSsn: data.useSsn,
            VendorName: data.vendorName,
            VendorName2: data.vendorName2,
            VendorNumber: !!create ? 0 : Number(data.vendorNumber),
            zipCode: data.zipCode
        };
        return ((createVendorPayload as unknown) as Vendor);
    };

    const GetIrsCategoryTypeIdFromString = (irsCategoryTypeString: string) => {
        switch (irsCategoryTypeString) {
            case 'Gross Proceeds Paid to Attorney':
            return '1';
        default:
            return '2';
        }
    };

    const removeVendor = async () => {
        const vendorNumber = vendors.items[selectedVendor].vendorNumber;
        let result = await del(`/v1.0/AccountsPayable/vendor/${vendorNumber}`);

        if (response.ok) {
            getVendors('');
        } else {
            console.log('Unable to delete charge vendor!' + result);
        }
    };

    const removeVendorDefaultAccount = async () => {
        const vendorNumber = vendors?.items[selectedVendor]?.vendorNumber;
        const accountNumber = vendorDefaultAccounts[selectedVendorDefaultAccount].accountNumber;
        let result = await del(`/v1.0/AccountsPayable/vendordefaultaccount?vendorNumber=${vendorNumber}&accountNumber=${accountNumber}`);

        if (response.ok) {
            getVendorDefaultAccounts(vendorNumber);
        } else {
            console.log('Unable to delete charge vendor!' + result);
        }
    };

    const addDefaultVendorAccount = async (vendorAccount: LedgerAccount) => {
        const vendorNumber = vendors.items[selectedVendor].vendorNumber;
        const payload = {
            vendorNumber: vendorNumber,
            accountNumber: vendorAccount.accountNumber
        };

        let result = await post(`/v1.0/AccountsPayable/vendors/defaultaccount/create`, payload);

        if (response.ok) {
            getVendorDefaultAccounts(vendorNumber);
        } else {
            console.log('Unable to add a vendor default account!' + result);
        }
    };

    const prepAddVendor = () => {
        reset(new Vendor());
        setValue(`vendorNumber`, 0);
        const vendorNameField = document.getElementById(`1vendorName1`);
        if (!!vendorNameField) {
            vendorNameField.focus();
        }
    };

    const addVendor = async (payload: Vendor) => {
        if (isDirty) {
            /*const formData = getValues();
             const payload = {
                vendorName: dirtyFields.vendorName,
                vendorName2: formData.vendorName2,
                address: formData.address,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zipCode: formData.zipcode,
                termNumber: formData.termNumber,
                phoneNumber: formData.phoneNumber,
                faxNumber: formData.faxNumber,
                emailAddress: formData.emailAddress,
                vendorAccount: formData.vendorAccountForTSDI1,
                contact: '',
                webPage: '',
                comments: '',
                taxId: formData.taxId,
                isHidden: '',
                taxType: GetIrsCategoryTypeIdFromString(formData.taxType),
                useSsn: formData.useSsn,
                isActive: formData.isActive === true ? 1 : 0
            }; */

            let result = await post(`/v1.0/AccountsPayable/vendors/create`, payload);

            if (response.ok) {
                getVendors('');
                showToast('Vendor created!');
            } else {
                console.log('Unable to add vendor!' + result);
                showToast('Unable to create vendor.', `rgba(255,0,0,0.5)`);
            }
        }
    };

    const updateVendor = async (payload: Vendor) => {
        if (isDirty) {
            /* const formData = getValues();
            const payload = {
                vendorNumber: vendors?.items[selectedVendor]?.vendorNumber,
                vendorName: formData.vendorName,
                vendorName2: formData.vendorName2,
                address: formData.address,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zipCode: formData.zipcode,
                termNumber: getTermNumber(formData.termNumber),
                phoneNumber: '',
                faxNumber: formData.fax,
                emailAddress: formData.email,
                vendorAccount: formData.vendorAccountForTSDI1,
                contact: '',
                webPage: '',
                comments: '',
                taxId: formData.taxIdNumber,
                isHidden: '',
                taxType: GetIrsCategoryTypeIdFromString(formData.taxType),
                useSsn: '',
                isActive: formData.isActive === true ? 1 : 0
            }; */

            console.log(payload);

            let result = await put(`/v1.0/AccountsPayable/vendor`, payload);

            if (response.ok) {
                getVendors('');
                showToast('Vendor saved!');
            } else {
                console.log('Unable to update vendor!' + result);
                showToast('Unable to save vendor.', `rgba(255,0,0,0.5)`);
            }
        }
    };

    const nextButtonClicked = () => {
        const newlySelectedVendor = selectedVendor < vendors?.items?.length ? selectedVendor + 1 : selectedVendor;
        if (selectedVendor >= vendors?.items?.length - 1) {
            incrementVendors();
        }
        setSelectedVendor(newlySelectedVendor);
        getVendorDefaultAccounts(vendors?.items[newlySelectedVendor]?.vendorNumber);
    };

    const previousButtonClicked = () => {
        const newlySelectedVendor = selectedVendor > 0 ? selectedVendor - 1 : 0;
        setSelectedVendor(newlySelectedVendor);
        getVendorDefaultAccounts(vendors?.items[newlySelectedVendor]?.vendorNumber);
    };

    const firstButtonClicked = () => {
        setSelectedVendor(0);
        getVendorDefaultAccounts(vendors?.items[0]?.vendorNumber);
    };

/*     const addVendor = () => {
    const findVendor = () => {
        showDialog(DialogList.FIND_VENDOR);
    };

    const addVendor = () => {
        showDialog(DialogList.ADD_VENDOR);
    }; */

    const findVendor = () => {
        dispatch(actions.layout.showDialog(DialogList.FIND_VENDOR));
    };

    const findAvailableAccounts = () => {
        dispatch(actions.layout.showDialog(DialogList.FIND_AVAILABLE_ACCOUNTS));
    };

    const addTerms = () => {
        showDialog(DialogList.AP_TERMS);
    };

    const reports = () => {
        showDialog(DialogList.VENDOR_REPORTS);
    };

    // Mirrors VouchersPage.tsx's handleVoucherSearch pattern for its own Vendor No. lookahead:
    // typing already narrows `vendors` live via onVendorSearchChange/setVendorSearchTerm, so Search
    // just needs to select the chosen match out of that already-narrowed list (same as clicking a
    // row in FindVendorDialog) rather than firing a second fetch. An empty search restores the
    // unfiltered list.
    const handleVendorSearch = (criteria: IVendorSearchCriteria) => {
        if (!criteria.vendorNumber) {
            setVendorSearchTerm('');
            resetVendorSearchOptions();
            return;
        }

        const index = vendors?.items?.findIndex(v => `${v.vendorNumber}` === criteria.vendorNumber) ?? -1;
        if (index >= 0) {
            setSelectedVendor(index);
            getVendorDefaultAccounts(vendors.items[index].vendorNumber);
        }
    };

    const goToLastRecord = () => {
        const lastIndex = vendors.items.length - 1;
        setSelectedVendor(lastIndex);
        getVendorDefaultAccounts(vendors.items[lastIndex]?.vendorNumber);
    };

    // Keeps the jump-to input in sync whenever the position changes via the nav buttons or a fresh
    // vendor list loads - mirrors DepositReconciliationPage.tsx's own depositNumberInput effect.
    useEffect(() => {
        setVendorPositionInput(vendors?.items?.length ? String(selectedVendor + 1) : '');
        setVendorPositionError('');
    }, [selectedVendor, vendors]);

    // Keeps the document-count badge next to the Documents button current as the user navigates -
    // the "DOCS" field beside the Documents button on the real Oracle screen (no corresponding
    // column on AP_VENDOR_DOCUMENT, so it's a form-only display value, not persisted data).
    useEffect(() => {
        const vendorNumber = vendors?.items[selectedVendor]?.vendorNumber;
        if (vendorNumber) {
            getVendorDocs(vendorNumber);
        } else {
            setVendorDocs([]);
        }
    }, [selectedVendor, vendors]);

    // Debounced so only actual keystrokes trigger a jump, same as DepositReconciliationPage.tsx's
    // validateAndJumpToDepositNumber. Position is 1-based, against the vendors currently loaded in
    // this search (same list Next/Previous/Last already page through), not the Vendor No. column.
    const jumpToVendorPosition = useRef(_.debounce((rawValue: string) => {
        const trimmed = rawValue.trim();

        if (!trimmed) {
            setVendorPositionError('');
            return;
        }

        if (!/^\d+$/.test(trimmed)) {
            setVendorPositionError('Must be a whole number.');
            return;
        }

        const enteredPosition = parseInt(trimmed, 10);
        const count = vendors?.items?.length ?? 0;

        if (count === 0) {
            setVendorPositionError('No vendors are loaded.');
            return;
        }

        if (enteredPosition < 1 || enteredPosition > count) {
            setVendorPositionError(`Must be between 1 and ${count}.`);
            return;
        }

        setVendorPositionError('');

        const targetIndex = enteredPosition - 1;
        setSelectedVendor(targetIndex);
        getVendorDefaultAccounts(vendors.items[targetIndex]?.vendorNumber);
    }, 500)).current;

    const handleVendorPositionInputChange = (event: React.FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        setVendorPositionInput(value);
        jumpToVendorPosition(value);
    };

    const addNewDefaultVendorAccount = (account: LedgerAccount) => {
        // This is where we'll call the service to add a new default vendor account
        addDefaultVendorAccount(account);
    };

    const displayWarning = (index: number) => {
        setSelectedVendorDefaultAccount(index);
        showDialog(DialogList.WARNING);
    };

    const handleConfirmDeleteVendorDefaultAccount = () => {
        removeVendorDefaultAccount();
        console.log('Delete Default vendor account');
    };

    const incrementVendors = () => {
        if (!!fetchNextPage) {
            // setFetchNextPage(vendors.pageNumber * vendors.pageSize < vendors.totalRecords);
            let newSearchOptions = _.cloneDeep(vendorSearchOptions);
            newSearchOptions.incrementPageNumber();
            setVendorSearchOptions(newSearchOptions);
        }
    };

    const displayAccounts = () => {
        return <div>
            <table style={{ width: '100%' }}>
                <thead style={{ textAlign: 'left' }}>
                    <tr>
                        <th>Account No.</th>
                        <th>Description</th>
                    </tr>
                </thead>
                {vendorDefaultAccounts?.map((account: VendorDefaultAccount, index: number) => {
                    return (
                        <tbody key={account.id}>
                            <tr className="table-item-hover">
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`accounts[${index}].accountNumber`}
                                        type="text"
                                        defaultVal={account.accountNumber + ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}                                        
                                        onDoubleClick={() => findAvailableAccounts()}
                                    />
                                </td>
                                <td style={{ width: '70%' }}>
                                    <RHFInputBox
                                        name={`accounts[${index}].description`}
                                        type="text"
                                        defaultVal={account.description + ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '70%' }}>
                                    <div className="form-row" style={{ margin: 0 }}>
                                        <Button 
                                            className="blue-hover-button"
                                            reactIcon={FaPlusCircle}
                                            iconStyle={{width: '1.5rem', height: '1.5rem', marginBottom: '.5rem'}}
                                            style={{ height: '3rem', background: 'transparent', padding: '0 1 0 0' }} 
                                            onClick={() => findAvailableAccounts()}
                                            title="Add New Default Account"
                                        />
                                        <Button 
                                            reactIcon={IoMdCloseCircleOutline} 
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            iconHoverColor="red"
                                            title="Remove Default Account"
                                            style={{ height: '3rem', background: 'transparent', padding: '0 0 0 0', marginTop: '.4rem' }} 
                                            onClick={() => displayWarning(index)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };

    return (
        <div>
            <APNavBar/>
            {toast && (
                <PersonnelToast
                    message={toast.message}
                    color={toast.color}
                    onClose={() => setToast(null)}
                    persistent={toast.persistent}
                />
            )}
            <Page>
                <Page.Section width={12}>
                    <VendorSearch
                        vendors={vendors}
                        onVendorSearchChange={setVendorSearchTerm}
                        onSearch={handleVendorSearch}
                        onAdvancedFind={findVendor}
                    />
                </Page.Section>
            </Page>
            <form id="employeePayForm" onSubmit={handleSubmit(onSubmit)}>
                <Page>
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="A/P Vendors">
                                <div style={{ padding: '.5rem' }}>
                                    <div className="form-row" style={{ alignItems: 'flex-end', justifyContent: 'center' }}>
                                        <Button
                                            style={{ height: '3rem', background: 'transparent' }}
                                            text={''}
                                            title="New Vendor"
                                            reactIcon={FaBuilding}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => prepAddVendor()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Delete"
                                            reactIcon={FaTrash}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => removeVendor()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Move to First Vendor"
                                            reactIcon={BiArrowToLeft}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => firstButtonClicked()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Move to Previous Vendor"
                                            reactIcon={BiLeftArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => previousButtonClicked()}
                                        />
                                        <input
                                            id={'selectVendorPosition'}
                                            type="text"
                                            inputMode="numeric"
                                            value={vendorPositionInput}
                                            onChange={(e) => handleVendorPositionInputChange(e)}
                                            title="Enter a position to jump to it"
                                            style={{
                                                fontWeight: 'bold',
                                                marginLeft: '1rem',
                                                width: '3rem',
                                                textAlign: 'center',
                                                border: vendorPositionError ? '2px solid red' : '1px solid #ccc',
                                                borderRadius: '4px',
                                                outline: 'none'
                                            }}
                                        />
                                        <label style={{ marginLeft: '.5rem', marginRight: '.5rem' }}>of</label>
                                        <label style={{ fontWeight: 'bold' }}>{vendors?.items?.length ?? 0}</label>
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Move to Next Vendor"
                                            reactIcon={BiRightArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => nextButtonClicked()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Move to Last Vendor"
                                            reactIcon={BiArrowToRight}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => goToLastRecord()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title={isDirty ? 'Save Changes' : 'No changes to save'}
                                            reactIcon={FaRegSave}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            disabled={!isDirty}
                                            type={'submit'}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Documents"
                                            reactIcon={FaFolderOpen}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            disabled={!vendors?.items[selectedVendor]?.vendorNumber}
                                            onClick={() => handleOpenVendorDocuments(vendors?.items[selectedVendor]?.vendorNumber)}
                                        />
                                        <label
                                            title="Number of documents attached to this vendor"
                                            style={{
                                                borderRadius: '4px',
                                                padding: '2px 8px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                backgroundColor: '#EFEFEF',
                                                border: '1px solid #999',
                                                marginLeft: '-1.25rem'
                                            }}
                                        >
                                            {vendorDocs?.length ?? 0}
                                        </label>
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="Reports"
                                            reactIcon={VscGraph}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem' }}
                                            onClick={() => reports()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                            text={''}
                                            title="1099 Maintenance"
                                            reactIcon={FaFileInvoice}
                                            iconHoverColor="blue"
                                            iconStyle={{ width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                            onClick={() => showDialog(DialogList.AP_1099_MAINTENANCE)}
                                        />
                                        {vendorPositionError &&
                                            <label style={{ color: 'red', marginLeft: '1rem' }}>{vendorPositionError}</label>
                                        }
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            disabled={true}
                                            label="Vendor No."
                                            name={`vendorNumber`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%', marginLeft: '.5rem' }}
                                            onDoubleClick={findVendor}
                                        />
                                        <RHFCheckbox
                                            name="isActive"
                                            checked={vendors?.items[selectedVendor]?.isActive === 1 ? true : false}
                                            label="Active"
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{ width: '10%', marginLeft: 'auto', marginTop: '1rem' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Name"
                                            id={`1vendorName1`}
                                            name={`vendorName`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            name={`vendorName2`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginTop: '1.7rem' }}
                                        />
                                        {isAccountingAdmin && <RHFCheckbox
                                            name="isHidden"
                                            checked={vendors?.items[selectedVendor]?.isHidden === 'Y' ? true : false}
                                            label="Hidden"
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{ width: '10%', marginTop: '1rem' }}
                                        />}
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Address"
                                            name={`address`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            name={`address2`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginTop: '1.7rem' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="City"
                                            name={`city`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFSelect
                                            bodyStyle={{ width: '20%' }}
                                            style={{ width: '100%' }}
                                            name="state"
                                            label="State"
                                            defaultVal={vendors?.items[selectedVendor]?.state}
                                            options={stateDropdownOptions()}
                                            register={register}
                                            errors={errors}
                                        />
                                        {/* <RHFInputBox
                                            label="State"
                                            name={`state`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        /> */}
                                        <RHFInputBox
                                            label="Zip Code"
                                            name={`zipCode`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Phone"
                                            name={`phoneNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="FAX"
                                            name={`faxNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFInputBox
                                            label="E-Mail"
                                            name={`emailAddress`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                        <RHFSelect
                                            label="Tax ID No."
                                            name={'useSsn'}
                                            defaultVal={vendors?.items[selectedVendor]?.useSsn}
                                            options={[
                                                { value: 'N', label: 'EIN' },
                                                { value: 'Y', label: 'SSN' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <Button
                                            className="blue-hover-button"
                                            style={{ width: '10%', height: '3rem', marginTop: '2rem' }}
                                            text={'Add Terms'}
                                            onClick={() => addTerms()}
                                        />
                                        <RHFSelect
                                            label="Terms"
                                            name={'termNumber'}
                                            defaultVal={vendors?.items[selectedVendor]?.termNumber + ''}
                                            options={termDescriptions ? termDescriptions : [
                                                { value: '0', label: 'Upon Receipt' },
                                                { value: '1', label: 'Net 15' },
                                                { value: '2', label: 'Net 30' },
                                                { value: '3', label: 'Net 45' },
                                                { value: '-1', label: 'Other' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%', marginLeft: '.5rem' }}
                                        />
                                        <RHFSelect
                                            label="IRS Category Type"
                                            name={'taxType'}
                                            defaultVal={vendors?.items[selectedVendor]?.taxType}
                                            options={[
                                                { value: 'G', label: 'Gross Proceeds Paid to Attorney' },
                                                { value: 'C', label: 'Nonemployee Compensation' },
                                                { value: 'X', label: 'Not Defined' },
                                                { value: 'N', label: 'Not Eligible - Entity Type' },
                                                { value: 'O', label: 'Not Eligible - Other' },
                                                { value: 'V', label: 'Not Eligible - Vendor Type' },
                                                { value: 'I', label: 'Other Income' },
                                                { value: 'R', label: 'Rents' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        {isAccountingAdmin && <RHFInputBox
                                            label="Vendor Account for TSDI"
                                            name={`vendorAccount`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />}
                                        <RHFInputBox
                                            label="Tax ID"
                                            name={`taxId`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page>
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="A/P Vendor Default Accounts">
                                <div className="tiny-panel" style={{ width: '100%', textAlign: 'center', overflowY: 'scroll' }}>
                                    {displayAccounts()}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <VendorReportsDialog
                    dialogName={DialogList.VENDOR_REPORTS}
                    hideDialog={hideDialog}
                    showDialog={showDialog}
                />
                <Ap1099MaintenanceDialog
                    dialogName={DialogList.AP_1099_MAINTENANCE}
                    hideDialog={hideDialog}
                    showDialog={showDialog}
                />
                <Ap1099ReportDialog
                    dialogName={DialogList.AP_1099_REPORT}
                    hideDialog={hideDialog}
                    showDialog={showDialog}
                />
                <CompanyMaintenanceDialog
                    dialogName={DialogList.COMPANY_MAINTENANCE}
                    hideDialog={hideDialog}
                    showDialog={showDialog}
                    backDialog={DialogList.AP_1099_MAINTENANCE}
                />
                <VendorExcelExportDialog
                    dialogName={DialogList.VENDOR_EXCEL_EXPORT}
                    hideDialog={hideDialog}
                />
                <AddVendorExDialog
                    dialogName={DialogList.ADD_VENDOR}
                    hideDialog={hideDialog}
                    states={states?.items}
                    termDescriptions={termDescriptions}
                />
                <FindVendorDialog
                    incrementVendors={incrementVendors}
                    resetVendorSearchOptions={resetVendorSearchOptions}
                    dialogName={DialogList.FIND_VENDOR} 
                    hideDialog={hideDialog}
                    vendors={vendors?.items}
                    setVendorSearchTerm={setVendorSearchTerm}
                    setSelectedVendor={setSelectedVendor}
                />
                <WarningDialog 
                    dialogName={DialogList.WARNING} 
                    hideDialog={hideDialog}
                    handleConfirm={handleConfirmDeleteVendorDefaultAccount}
                />
                <FindAvailableAccountsDialog 
                    dialogName={DialogList.FIND_AVAILABLE_ACCOUNTS} 
                    handleOKClicked={addNewDefaultVendorAccount}
                    hideDialog={hideDialog}
                />
                <APTermsDialog
                    dialogName={DialogList.AP_TERMS}
                    hideDialog={hideDialog}
                    handleTerms={handleTerms}
                />
                <VendorDocumentManagementDialog
                    dialogName={DialogList.MANAGE_VENDOR_DOCUMENTS}
                    documentList={vendorDocs}
                    addDocument={handleAddVendorDoc}
                    updateDocument={handleUpdateVendorDoc}
                    deleteDocument={handleDeleteVendorDoc}
                    downloadDocument={handleDownloadVendorDoc}
                    hideDialog={hideDialog}
                />
            </form>
        </div>
    );
};

export default VendorsPage;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/pages/VendorsPage.tsx